
































































import Vue from 'vue';
import { diffLines } from 'diff';
import { Type, AnyType, Program } from 'expangine-runtime';
import { Registry } from '../runtime/Registry';
import { LiveRuntime } from 'expangine-runtime-live';
import { measure } from './StopWatch';
import { TypeSettings } from '../runtime/types/TypeVisuals';


interface Part { value: string; added: boolean; removed: boolean; }
const getColor = (part: Part): string => part.added ? 'added' : part.removed ? 'removed' : '';

export default Vue.extend({
  props: {
    program: {
      type: Object as () => Program,
      required: true,
    },
    registry: {
      type: Object as () => Registry,
      required: true,
    },
  },
  data: () => ({
    dataString: '',
    dataAfter: null,
    dataAfterString: '',
    result: null,
    elapsedTime: '',
    tab: null,
  }),
  computed: {
    resultType(): Type {
      const described = this.registry.defs.describe(this.result);
      if (described) {
        described.removeDescribedRestrictions();
      }
      return described || AnyType.baseType;
    },
    resultSettings(): TypeSettings {
      return this.registry.getTypeSettings(this.resultType);
    },
    rawString(): string {
      return JSON.stringify(this.resultType.toJson(this.result), undefined, 2);
    },
    showData(): boolean {
      return this.dataString !== this.dataAfterString;
    },
    diffString(): string {
      return diffLines(this.dataString, this.dataAfterString)
        .map((part: Part) => `<span class="${getColor(part)}">${part.value}</span>`)
        .join('')
      ;
    },
    isOutputInterface(): boolean {
      return this.tab === 2;
    },
  },
  watch: {
    program: {
      immediate: true,
      handler(program: Program) {
        const { dataType: type, datasets, expression } = program;
        const data = type.fromJson(type.toJson(datasets[0].data));
        const { elapsedSummary, result } = measure(() => LiveRuntime.run(expression, data));

        this.elapsedTime = elapsedSummary;
        this.dataAfter = data;
        this.result = result;
      },
    },
  },
});
